import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface BairroAtendido {
    id: number
    idBairro: number
    nomeBairro: string
    idCidade: number
    nomeCidade: string
    taxaEntrega: string
    taxaEntregaNoturna: string | null
    minimoEntregaGratis: string | null
    taxaEntregador: string | null
    versao: number | null
}

export interface BairroDisponivel {
    id: number
    nome: string
    idCidade: number
    nomeCidade: string
}

export interface BairrosDbData {
    atendidos: BairroAtendido[]
    naoAtendidos: BairroDisponivel[]
}

export interface AdicionarBairroPayload {
    idBairro: number
    taxaEntrega: string
    taxaEntregaNoturna: string | null
    minimoEntregaGratis: string | null
    taxaEntregador: string | null
}

export interface AtualizarTaxaPayload {
    taxaEntrega: string
    taxaEntregaNoturna: string | null
    minimoEntregaGratis: string | null
    taxaEntregador: string | null
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

const ErroRequisicao = function (error: { message?: string }): string | false {
    if (error.message === "Network Error") return "Verifique sua conexão!"
    if (error.message) return "Erro: " + error.message
    return false
}

export const obterBairrosDb = async function (
    authorization: string,
    idEstabelecimento: number,
    idCidade: number | null
): Promise<BairrosDbData | ErroApi> {
    try {
        const url = idCidade
            ? `endereco/bairros-db/${idEstabelecimento}?idCidade=${idCidade}`
            : `endereco/bairros-db/${idEstabelecimento}`
        const response = await api
            .get<BairrosDbData | RespostaErroRaw>(url, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as BairrosDbData
    } catch (error) {
        RegistrarLogErro(error, "obterBairrosDb", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const adicionarBairrosDb = async function (
    authorization: string,
    idEstabelecimento: number,
    idCidade: number,
    bairros: AdicionarBairroPayload[]
): Promise<BairrosDbData | ErroApi> {
    try {
        const response = await api
            .post<BairrosDbData | RespostaErroRaw>(
                `endereco/bairros-db/${idEstabelecimento}`,
                { idCidade, bairros },
                { headers: { "Content-Type": "application/json", Authorization: authorization } }
            )
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as BairrosDbData
    } catch (error) {
        RegistrarLogErro(error, "adicionarBairrosDb", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const atualizarTaxaBairroDb = async function (
    authorization: string,
    idBairroEstabelecimento: number,
    payload: AtualizarTaxaPayload
): Promise<BairroAtendido | ErroApi> {
    try {
        const response = await api
            .put<BairroAtendido | RespostaErroRaw>(
                `endereco/bairros-db/${idBairroEstabelecimento}`,
                payload,
                { headers: { "Content-Type": "application/json", Authorization: authorization } }
            )
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as BairroAtendido
    } catch (error) {
        RegistrarLogErro(error, "atualizarTaxaBairroDb", String(idBairroEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const excluirBairroDb = async function (
    authorization: string,
    idBairroEstabelecimento: number
): Promise<void | ErroApi> {
    try {
        const response = await api
            .delete<RespostaErroRaw | null>(`endereco/bairros-db/${idBairroEstabelecimento}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (response.data && isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
    } catch (error) {
        RegistrarLogErro(error, "excluirBairroDb", String(idBairroEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
